import Amplitude from "amplitude-js";
export class AnalyticsService {
    static logEvent(eventName, props = {}) {
        Amplitude.getInstance().logEvent(eventName, props, () => {
            // Callback
        });
    }

    static identifyUser(userId) {
        Amplitude.getInstance().setUserId(userId);
    }

    static reset() {
        Amplitude.reset();
    }
}
